module.exports = __webpack_public_path__ + "img/mono_32.06bffd58.png";